import { getCurrentUser as A, onRequestTokenUpdate as ue, getRequestToken as de } from "@nextcloud/auth";
import { getLoggerBuilder as q } from "@nextcloud/logger";
import { getCanonicalLocale as ae } from "@nextcloud/l10n";
import { join as le, basename as fe, extname as ce, dirname as I } from "path";
import { encodePath as he } from "@nextcloud/paths";
import { generateRemoteUrl as pe } from "@nextcloud/router";
import { createClient as ge, getPatcher as we } from "webdav";
/**
 * @copyright 2019 Christoph Wurst <christoph@winzerhof-wurst.at>
 *
 * @author Christoph Wurst <christoph@winzerhof-wurst.at>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
const me = (e) => e === null ? q().setApp("files").build() : q().setApp("files").setUid(e.uid).build(), m = me(A());
/**
 * @copyright Copyright (c) 2021 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
class Ne {
  _entries = [];
  registerEntry(t) {
    this.validateEntry(t), this._entries.push(t);
  }
  unregisterEntry(t) {
    const r = typeof t == "string" ? this.getEntryIndex(t) : this.getEntryIndex(t.id);
    if (r === -1) {
      m.warn("Entry not found, nothing removed", { entry: t, entries: this.getEntries() });
      return;
    }
    this._entries.splice(r, 1);
  }
  /**
   * Get the list of registered entries
   *
   * @param {Folder} context the creation context. Usually the current folder
   */
  getEntries(t) {
    return t ? this._entries.filter((r) => typeof r.enabled == "function" ? r.enabled(t) : !0) : this._entries;
  }
  getEntryIndex(t) {
    return this._entries.findIndex((r) => r.id === t);
  }
  validateEntry(t) {
    if (!t.id || !t.displayName || !(t.iconSvgInline || t.iconClass) || !t.handler)
      throw new Error("Invalid entry");
    if (typeof t.id != "string" || typeof t.displayName != "string")
      throw new Error("Invalid id or displayName property");
    if (t.iconClass && typeof t.iconClass != "string" || t.iconSvgInline && typeof t.iconSvgInline != "string")
      throw new Error("Invalid icon provided");
    if (t.enabled !== void 0 && typeof t.enabled != "function")
      throw new Error("Invalid enabled property");
    if (typeof t.handler != "function")
      throw new Error("Invalid handler property");
    if ("order" in t && typeof t.order != "number")
      throw new Error("Invalid order property");
    if (this.getEntryIndex(t.id) !== -1)
      throw new Error("Duplicate entry");
  }
}
const F = function() {
  return typeof window._nc_newfilemenu > "u" && (window._nc_newfilemenu = new Ne(), m.debug("NewFileMenu initialized")), window._nc_newfilemenu;
};
/**
 * @copyright 2019 Christoph Wurst <christoph@winzerhof-wurst.at>
 *
 * @author Christoph Wurst <christoph@winzerhof-wurst.at>
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
const C = ["B", "KB", "MB", "GB", "TB", "PB"], P = ["B", "KiB", "MiB", "GiB", "TiB", "PiB"];
function Yt(e, t = !1, r = !1, s = !1) {
  r = r && !s, typeof e == "string" && (e = Number(e));
  let n = e > 0 ? Math.floor(Math.log(e) / Math.log(s ? 1e3 : 1024)) : 0;
  n = Math.min((r ? P.length : C.length) - 1, n);
  const i = r ? P[n] : C[n];
  let d = (e / Math.pow(s ? 1e3 : 1024, n)).toFixed(1);
  return t === !0 && n === 0 ? (d !== "0.0" ? "< 1 " : "0 ") + (r ? P[1] : C[1]) : (n < 2 ? d = parseFloat(d).toFixed(0) : d = parseFloat(d).toLocaleString(ae()), d + " " + i);
}
function Jt(e, t = !1) {
  try {
    e = `${e}`.toLocaleLowerCase().replaceAll(/\s+/g, "").replaceAll(",", ".");
  } catch {
    return null;
  }
  const r = e.match(/^([0-9]*(\.[0-9]*)?)([kmgtp]?)(i?)b?$/);
  if (r === null || r[1] === "." || r[1] === "")
    return null;
  const s = {
    "": 0,
    k: 1,
    m: 2,
    g: 3,
    t: 4,
    p: 5,
    e: 6
  }, n = `${r[1]}`, i = r[4] === "i" || t ? 1024 : 1e3;
  return Math.round(Number.parseFloat(n) * i ** s[r[3]]);
}
/**
 * @copyright Copyright (c) 2023 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
var Z = /* @__PURE__ */ ((e) => (e.DEFAULT = "default", e.HIDDEN = "hidden", e))(Z || {});
class Qt {
  _action;
  constructor(t) {
    this.validateAction(t), this._action = t;
  }
  get id() {
    return this._action.id;
  }
  get displayName() {
    return this._action.displayName;
  }
  get title() {
    return this._action.title;
  }
  get iconSvgInline() {
    return this._action.iconSvgInline;
  }
  get enabled() {
    return this._action.enabled;
  }
  get exec() {
    return this._action.exec;
  }
  get execBatch() {
    return this._action.execBatch;
  }
  get order() {
    return this._action.order;
  }
  get parent() {
    return this._action.parent;
  }
  get default() {
    return this._action.default;
  }
  get inline() {
    return this._action.inline;
  }
  get renderInline() {
    return this._action.renderInline;
  }
  validateAction(t) {
    if (!t.id || typeof t.id != "string")
      throw new Error("Invalid id");
    if (!t.displayName || typeof t.displayName != "function")
      throw new Error("Invalid displayName function");
    if ("title" in t && typeof t.title != "function")
      throw new Error("Invalid title function");
    if (!t.iconSvgInline || typeof t.iconSvgInline != "function")
      throw new Error("Invalid iconSvgInline function");
    if (!t.exec || typeof t.exec != "function")
      throw new Error("Invalid exec function");
    if ("enabled" in t && typeof t.enabled != "function")
      throw new Error("Invalid enabled function");
    if ("execBatch" in t && typeof t.execBatch != "function")
      throw new Error("Invalid execBatch function");
    if ("order" in t && typeof t.order != "number")
      throw new Error("Invalid order");
    if ("parent" in t && typeof t.parent != "string")
      throw new Error("Invalid parent");
    if (t.default && !Object.values(Z).includes(t.default))
      throw new Error("Invalid default");
    if ("inline" in t && typeof t.inline != "function")
      throw new Error("Invalid inline function");
    if ("renderInline" in t && typeof t.renderInline != "function")
      throw new Error("Invalid renderInline function");
  }
}
const Dt = function(e) {
  if (typeof window._nc_fileactions > "u" && (window._nc_fileactions = [], m.debug("FileActions initialized")), window._nc_fileactions.find((t) => t.id === e.id)) {
    m.error(`FileAction ${e.id} already registered`, { action: e });
    return;
  }
  window._nc_fileactions.push(e);
}, er = function() {
  return typeof window._nc_fileactions > "u" && (window._nc_fileactions = [], m.debug("FileActions initialized")), window._nc_fileactions;
};
/**
 * @copyright Copyright (c) 2023 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
class tr {
  _header;
  constructor(t) {
    this.validateHeader(t), this._header = t;
  }
  get id() {
    return this._header.id;
  }
  get order() {
    return this._header.order;
  }
  get enabled() {
    return this._header.enabled;
  }
  get render() {
    return this._header.render;
  }
  get updated() {
    return this._header.updated;
  }
  validateHeader(t) {
    if (!t.id || !t.render || !t.updated)
      throw new Error("Invalid header: id, render and updated are required");
    if (typeof t.id != "string")
      throw new Error("Invalid id property");
    if (t.enabled !== void 0 && typeof t.enabled != "function")
      throw new Error("Invalid enabled property");
    if (t.render && typeof t.render != "function")
      throw new Error("Invalid render property");
    if (t.updated && typeof t.updated != "function")
      throw new Error("Invalid updated property");
  }
}
const rr = function(e) {
  if (typeof window._nc_filelistheader > "u" && (window._nc_filelistheader = [], m.debug("FileListHeaders initialized")), window._nc_filelistheader.find((t) => t.id === e.id)) {
    m.error(`Header ${e.id} already registered`, { header: e });
    return;
  }
  window._nc_filelistheader.push(e);
}, nr = function() {
  return typeof window._nc_filelistheader > "u" && (window._nc_filelistheader = [], m.debug("FileListHeaders initialized")), window._nc_filelistheader;
};
/**
 * @copyright Copyright (c) 2022 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
var N = /* @__PURE__ */ ((e) => (e[e.NONE = 0] = "NONE", e[e.CREATE = 4] = "CREATE", e[e.READ = 1] = "READ", e[e.UPDATE = 2] = "UPDATE", e[e.DELETE = 8] = "DELETE", e[e.SHARE = 16] = "SHARE", e[e.ALL = 31] = "ALL", e))(N || {});
/**
 * @copyright Copyright (c) 2023 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 * @author Ferdinand Thiessen <opensource@fthiessen.de>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
const j = [
  "d:getcontentlength",
  "d:getcontenttype",
  "d:getetag",
  "d:getlastmodified",
  "d:quota-available-bytes",
  "d:resourcetype",
  "nc:has-preview",
  "nc:is-encrypted",
  "nc:mount-type",
  "nc:share-attributes",
  "oc:comments-unread",
  "oc:favorite",
  "oc:fileid",
  "oc:owner-display-name",
  "oc:owner-id",
  "oc:permissions",
  "oc:share-types",
  "oc:size",
  "ocs:share-permissions"
], Y = {
  d: "DAV:",
  nc: "http://nextcloud.org/ns",
  oc: "http://owncloud.org/ns",
  ocs: "http://open-collaboration-services.org/ns"
}, ir = function(e, t = { nc: "http://nextcloud.org/ns" }) {
  typeof window._nc_dav_properties > "u" && (window._nc_dav_properties = [...j], window._nc_dav_namespaces = { ...Y });
  const r = { ...window._nc_dav_namespaces, ...t };
  if (window._nc_dav_properties.find((n) => n === e))
    return m.error(`${e} already registered`, { prop: e }), !1;
  if (e.startsWith("<") || e.split(":").length !== 2)
    return m.error(`${e} is not valid. See example: 'oc:fileid'`, { prop: e }), !1;
  const s = e.split(":")[0];
  return r[s] ? (window._nc_dav_properties.push(e), window._nc_dav_namespaces = r, !0) : (m.error(`${e} namespace unknown`, { prop: e, namespaces: r }), !1);
}, V = function() {
  return typeof window._nc_dav_properties > "u" && (window._nc_dav_properties = [...j]), window._nc_dav_properties.map((e) => `<${e} />`).join(" ");
}, L = function() {
  return typeof window._nc_dav_namespaces > "u" && (window._nc_dav_namespaces = { ...Y }), Object.keys(window._nc_dav_namespaces).map((e) => `xmlns:${e}="${window._nc_dav_namespaces?.[e]}"`).join(" ");
}, sr = function() {
  return `<?xml version="1.0"?>
		<d:propfind ${L()}>
			<d:prop>
				${V()}
			</d:prop>
		</d:propfind>`;
}, Ee = function() {
  return `<?xml version="1.0"?>
		<oc:filter-files ${L()}>
			<d:prop>
				${V()}
			</d:prop>
			<oc:filter-rules>
				<oc:favorite>1</oc:favorite>
			</oc:filter-rules>
		</oc:filter-files>`;
}, or = function(e) {
  return `<?xml version="1.0" encoding="UTF-8"?>
<d:searchrequest ${L()}
	xmlns:ns="https://github.com/icewind1991/SearchDAV/ns">
	<d:basicsearch>
		<d:select>
			<d:prop>
				${V()}
			</d:prop>
		</d:select>
		<d:from>
			<d:scope>
				<d:href>/files/${A()?.uid}/</d:href>
				<d:depth>infinity</d:depth>
			</d:scope>
		</d:from>
		<d:where>
			<d:and>
				<d:or>
					<d:not>
						<d:eq>
							<d:prop>
								<d:getcontenttype/>
							</d:prop>
							<d:literal>httpd/unix-directory</d:literal>
						</d:eq>
					</d:not>
					<d:eq>
						<d:prop>
							<oc:size/>
						</d:prop>
						<d:literal>0</d:literal>
					</d:eq>
				</d:or>
				<d:gt>
					<d:prop>
						<d:getlastmodified/>
					</d:prop>
					<d:literal>${e}</d:literal>
				</d:gt>
			</d:and>
		</d:where>
		<d:orderby>
			<d:order>
				<d:prop>
					<d:getlastmodified/>
				</d:prop>
				<d:descending/>
			</d:order>
		</d:orderby>
		<d:limit>
			<d:nresults>100</d:nresults>
			<ns:firstresult>0</ns:firstresult>
		</d:limit>
	</d:basicsearch>
</d:searchrequest>`;
};
/**
 * @copyright Copyright (c) 2023 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 * @author Ferdinand Thiessen <opensource@fthiessen.de>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
const be = function(e = "") {
  let t = N.NONE;
  return e && ((e.includes("C") || e.includes("K")) && (t |= N.CREATE), e.includes("G") && (t |= N.READ), (e.includes("W") || e.includes("N") || e.includes("V")) && (t |= N.UPDATE), e.includes("D") && (t |= N.DELETE), e.includes("R") && (t |= N.SHARE)), t;
};
/**
 * @copyright Copyright (c) 2022 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
var R = /* @__PURE__ */ ((e) => (e.Folder = "folder", e.File = "file", e))(R || {});
/**
 * @copyright Copyright (c) 2022 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
const J = function(e, t) {
  return e.match(t) !== null;
}, X = (e, t) => {
  if (e.id && typeof e.id != "number")
    throw new Error("Invalid id type of value");
  if (!e.source)
    throw new Error("Missing mandatory source");
  try {
    new URL(e.source);
  } catch {
    throw new Error("Invalid source format, source must be a valid URL");
  }
  if (!e.source.startsWith("http"))
    throw new Error("Invalid source format, only http(s) is supported");
  if (e.mtime && !(e.mtime instanceof Date))
    throw new Error("Invalid mtime type");
  if (e.crtime && !(e.crtime instanceof Date))
    throw new Error("Invalid crtime type");
  if (!e.mime || typeof e.mime != "string" || !e.mime.match(/^[-\w.]+\/[-+\w.]+$/gi))
    throw new Error("Missing or invalid mandatory mime");
  if ("size" in e && typeof e.size != "number" && e.size !== void 0)
    throw new Error("Invalid size type");
  if ("permissions" in e && e.permissions !== void 0 && !(typeof e.permissions == "number" && e.permissions >= N.NONE && e.permissions <= N.ALL))
    throw new Error("Invalid permissions");
  if (e.owner && e.owner !== null && typeof e.owner != "string")
    throw new Error("Invalid owner type");
  if (e.attributes && typeof e.attributes != "object")
    throw new Error("Invalid attributes type");
  if (e.root && typeof e.root != "string")
    throw new Error("Invalid root type");
  if (e.root && !e.root.startsWith("/"))
    throw new Error("Root must start with a leading slash");
  if (e.root && !e.source.includes(e.root))
    throw new Error("Root must be part of the source");
  if (e.root && J(e.source, t)) {
    const r = e.source.match(t)[0];
    if (!e.source.includes(le(r, e.root)))
      throw new Error("The root must be relative to the service. e.g /files/emma");
  }
  if (e.status && !Object.values(Q).includes(e.status))
    throw new Error("Status must be a valid NodeStatus");
};
/**
 * @copyright Copyright (c) 2022 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
var Q = /* @__PURE__ */ ((e) => (e.NEW = "new", e.FAILED = "failed", e.LOADING = "loading", e.LOCKED = "locked", e))(Q || {});
class D {
  _data;
  _attributes;
  _knownDavService = /(remote|public)\.php\/(web)?dav/i;
  constructor(t, r) {
    X(t, r || this._knownDavService), this._data = t;
    const s = {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      set: (n, i, d) => (this.updateMtime(), Reflect.set(n, i, d)),
      deleteProperty: (n, i) => (this.updateMtime(), Reflect.deleteProperty(n, i))
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    };
    this._attributes = new Proxy(t.attributes || {}, s), delete this._data.attributes, r && (this._knownDavService = r);
  }
  /**
   * Get the source url to this object
   */
  get source() {
    return this._data.source.replace(/\/$/i, "");
  }
  /**
   * Get the encoded source url to this object for requests purposes
   */
  get encodedSource() {
    const { origin: t } = new URL(this.source);
    return t + he(this.source.slice(t.length));
  }
  /**
   * Get this object name
   */
  get basename() {
    return fe(this.source);
  }
  /**
   * Get this object's extension
   */
  get extension() {
    return ce(this.source);
  }
  /**
   * Get the directory path leading to this object
   * Will use the relative path to root if available
   */
  get dirname() {
    if (this.root) {
      let r = this.source;
      this.isDavRessource && (r = r.split(this._knownDavService).pop());
      const s = r.indexOf(this.root), n = this.root.replace(/\/$/, "");
      return I(r.slice(s + n.length) || "/");
    }
    const t = new URL(this.source);
    return I(t.pathname);
  }
  /**
   * Get the file mime
   */
  get mime() {
    return this._data.mime;
  }
  /**
   * Get the file modification time
   */
  get mtime() {
    return this._data.mtime;
  }
  /**
   * Get the file creation time
   */
  get crtime() {
    return this._data.crtime;
  }
  /**
   * Get the file size
   */
  get size() {
    return this._data.size;
  }
  /**
   * Get the file attribute
   */
  get attributes() {
    return this._attributes;
  }
  /**
   * Get the file permissions
   */
  get permissions() {
    return this.owner === null && !this.isDavRessource ? N.READ : this._data.permissions !== void 0 ? this._data.permissions : N.NONE;
  }
  /**
   * Get the file owner
   */
  get owner() {
    return this.isDavRessource ? this._data.owner : null;
  }
  /**
   * Is this a dav-related ressource ?
   */
  get isDavRessource() {
    return J(this.source, this._knownDavService);
  }
  /**
   * Get the dav root of this object
   */
  get root() {
    return this._data.root ? this._data.root.replace(/^(.+)\/$/, "$1") : this.isDavRessource && I(this.source).split(this._knownDavService).pop() || null;
  }
  /**
   * Get the absolute path of this object relative to the root
   */
  get path() {
    if (this.root) {
      let t = this.source;
      this.isDavRessource && (t = t.split(this._knownDavService).pop());
      const r = t.indexOf(this.root), s = this.root.replace(/\/$/, "");
      return t.slice(r + s.length) || "/";
    }
    return (this.dirname + "/" + this.basename).replace(/\/\//g, "/");
  }
  /**
   * Get the node id if defined.
   * Will look for the fileid in attributes if undefined.
   */
  get fileid() {
    return this._data?.id || this.attributes?.fileid;
  }
  /**
   * Get the node status.
   */
  get status() {
    return this._data?.status;
  }
  /**
   * Set the node status.
   */
  set status(t) {
    this._data.status = t;
  }
  /**
   * Move the node to a new destination
   *
   * @param {string} destination the new source.
   * e.g. https://cloud.domain.com/remote.php/dav/files/emma/Photos/picture.jpg
   */
  move(t) {
    X({ ...this._data, source: t }, this._knownDavService), this._data.source = t, this.updateMtime();
  }
  /**
   * Rename the node
   * This aliases the move method for easier usage
   *
   * @param basename The new name of the node
   */
  rename(t) {
    if (t.includes("/"))
      throw new Error("Invalid basename");
    this.move(I(this.source) + "/" + t);
  }
  /**
   * Update the mtime if exists.
   */
  updateMtime() {
    this._data.mtime && (this._data.mtime = /* @__PURE__ */ new Date());
  }
}
/**
 * @copyright Copyright (c) 2022 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
class ye extends D {
  get type() {
    return R.File;
  }
}
/**
 * @copyright Copyright (c) 2022 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
class _e extends D {
  constructor(t) {
    super({
      ...t,
      mime: "httpd/unix-directory"
    });
  }
  get type() {
    return R.Folder;
  }
  get extension() {
    return null;
  }
  get mime() {
    return "httpd/unix-directory";
  }
}
/**
 * @copyright Copyright (c) 2023 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 * @author Ferdinand Thiessen <opensource@fthiessen.de>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
const ee = `/files/${A()?.uid}`, te = pe("dav"), ur = function(e = te, t = {}) {
  const r = ge(e, { headers: t });
  function s(i) {
    r.setHeaders({
      ...t,
      // Add this so the server knows it is an request from the browser
      "X-Requested-With": "XMLHttpRequest",
      // Inject user auth
      requesttoken: i ?? ""
    });
  }
  return ue(s), s(de()), we().patch("fetch", (i, d) => {
    const u = d.headers;
    return u?.method && (d.method = u.method, delete u.method), fetch(i, d);
  }), r;
}, dr = async (e, t = "/", r = ee) => (await e.getDirectoryContents(`${r}${t}`, {
  details: !0,
  data: Ee(),
  headers: {
    // see davGetClient for patched webdav client
    method: "REPORT"
  },
  includeSelf: !0
})).data.filter((n) => n.filename !== t).map((n) => ve(n, r)), ve = function(e, t = ee, r = te) {
  const s = e.props, n = be(s?.permissions), i = s?.["owner-id"] || A()?.uid, d = {
    id: s?.fileid || 0,
    source: `${r}${e.filename}`,
    mtime: new Date(Date.parse(e.lastmod)),
    mime: e.mime,
    size: s?.size || Number.parseInt(s.getcontentlength || "0"),
    permissions: n,
    owner: i,
    root: t,
    attributes: {
      ...e,
      ...s,
      hasPreview: s?.["has-preview"]
    }
  };
  return delete d.attributes?.props, e.type === "file" ? new ye(d) : new _e(d);
};
/**
 * @copyright Copyright (c) 2022 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
class Te {
  _views = [];
  _currentView = null;
  register(t) {
    if (this._views.find((r) => r.id === t.id))
      throw new Error(`View id ${t.id} is already registered`);
    this._views.push(t);
  }
  remove(t) {
    const r = this._views.findIndex((s) => s.id === t);
    r !== -1 && this._views.splice(r, 1);
  }
  get views() {
    return this._views;
  }
  setActive(t) {
    this._currentView = t;
  }
  get active() {
    return this._currentView;
  }
}
const ar = function() {
  return typeof window._nc_navigation > "u" && (window._nc_navigation = new Te(), m.debug("Navigation service initialized")), window._nc_navigation;
};
/**
 * @copyright Copyright (c) 2022 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
class Ie {
  _column;
  constructor(t) {
    Ae(t), this._column = t;
  }
  get id() {
    return this._column.id;
  }
  get title() {
    return this._column.title;
  }
  get render() {
    return this._column.render;
  }
  get sort() {
    return this._column.sort;
  }
  get summary() {
    return this._column.summary;
  }
}
const Ae = function(e) {
  if (!e.id || typeof e.id != "string")
    throw new Error("A column id is required");
  if (!e.title || typeof e.title != "string")
    throw new Error("A column title is required");
  if (!e.render || typeof e.render != "function")
    throw new Error("A render function is required");
  if (e.sort && typeof e.sort != "function")
    throw new Error("Column sortFunction must be a function");
  if (e.summary && typeof e.summary != "function")
    throw new Error("Column summary must be a function");
  return !0;
};
var S = {}, O = {};
(function(e) {
  const t = ":A-Za-z_\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", r = t + "\\-.\\d\\u00B7\\u0300-\\u036F\\u203F-\\u2040", s = "[" + t + "][" + r + "]*", n = new RegExp("^" + s + "$"), i = function(u, o) {
    const a = [];
    let l = o.exec(u);
    for (; l; ) {
      const f = [];
      f.startIndex = o.lastIndex - l[0].length;
      const c = l.length;
      for (let g = 0; g < c; g++)
        f.push(l[g]);
      a.push(f), l = o.exec(u);
    }
    return a;
  }, d = function(u) {
    const o = n.exec(u);
    return !(o === null || typeof o > "u");
  };
  e.isExist = function(u) {
    return typeof u < "u";
  }, e.isEmptyObject = function(u) {
    return Object.keys(u).length === 0;
  }, e.merge = function(u, o, a) {
    if (o) {
      const l = Object.keys(o), f = l.length;
      for (let c = 0; c < f; c++)
        a === "strict" ? u[l[c]] = [o[l[c]]] : u[l[c]] = o[l[c]];
    }
  }, e.getValue = function(u) {
    return e.isExist(u) ? u : "";
  }, e.isName = d, e.getAllMatches = i, e.nameRegexp = s;
})(O);
const M = O, Oe = {
  allowBooleanAttributes: !1,
  //A tag can have attributes without any value
  unpairedTags: []
};
S.validate = function(e, t) {
  t = Object.assign({}, Oe, t);
  const r = [];
  let s = !1, n = !1;
  e[0] === "\uFEFF" && (e = e.substr(1));
  for (let i = 0; i < e.length; i++)
    if (e[i] === "<" && e[i + 1] === "?") {
      if (i += 2, i = G(e, i), i.err)
        return i;
    } else if (e[i] === "<") {
      let d = i;
      if (i++, e[i] === "!") {
        i = z(e, i);
        continue;
      } else {
        let u = !1;
        e[i] === "/" && (u = !0, i++);
        let o = "";
        for (; i < e.length && e[i] !== ">" && e[i] !== " " && e[i] !== "	" && e[i] !== `
` && e[i] !== "\r"; i++)
          o += e[i];
        if (o = o.trim(), o[o.length - 1] === "/" && (o = o.substring(0, o.length - 1), i--), !Re(o)) {
          let f;
          return o.trim().length === 0 ? f = "Invalid space after '<'." : f = "Tag '" + o + "' is an invalid name.", p("InvalidTag", f, w(e, i));
        }
        const a = xe(e, i);
        if (a === !1)
          return p("InvalidAttr", "Attributes for '" + o + "' have open quote.", w(e, i));
        let l = a.value;
        if (i = a.index, l[l.length - 1] === "/") {
          const f = i - l.length;
          l = l.substring(0, l.length - 1);
          const c = H(l, t);
          if (c === !0)
            s = !0;
          else
            return p(c.err.code, c.err.msg, w(e, f + c.err.line));
        } else if (u)
          if (a.tagClosed) {
            if (l.trim().length > 0)
              return p("InvalidTag", "Closing tag '" + o + "' can't have attributes or invalid starting.", w(e, d));
            {
              const f = r.pop();
              if (o !== f.tagName) {
                let c = w(e, f.tagStartPos);
                return p(
                  "InvalidTag",
                  "Expected closing tag '" + f.tagName + "' (opened in line " + c.line + ", col " + c.col + ") instead of closing tag '" + o + "'.",
                  w(e, d)
                );
              }
              r.length == 0 && (n = !0);
            }
          } else
            return p("InvalidTag", "Closing tag '" + o + "' doesn't have proper closing.", w(e, i));
        else {
          const f = H(l, t);
          if (f !== !0)
            return p(f.err.code, f.err.msg, w(e, i - l.length + f.err.line));
          if (n === !0)
            return p("InvalidXml", "Multiple possible root nodes found.", w(e, i));
          t.unpairedTags.indexOf(o) !== -1 || r.push({ tagName: o, tagStartPos: d }), s = !0;
        }
        for (i++; i < e.length; i++)
          if (e[i] === "<")
            if (e[i + 1] === "!") {
              i++, i = z(e, i);
              continue;
            } else if (e[i + 1] === "?") {
              if (i = G(e, ++i), i.err)
                return i;
            } else
              break;
          else if (e[i] === "&") {
            const f = Ve(e, i);
            if (f == -1)
              return p("InvalidChar", "char '&' is not expected.", w(e, i));
            i = f;
          } else if (n === !0 && !U(e[i]))
            return p("InvalidXml", "Extra text at the end", w(e, i));
        e[i] === "<" && i--;
      }
    } else {
      if (U(e[i]))
        continue;
      return p("InvalidChar", "char '" + e[i] + "' is not expected.", w(e, i));
    }
  if (s) {
    if (r.length == 1)
      return p("InvalidTag", "Unclosed tag '" + r[0].tagName + "'.", w(e, r[0].tagStartPos));
    if (r.length > 0)
      return p("InvalidXml", "Invalid '" + JSON.stringify(r.map((i) => i.tagName), null, 4).replace(/\r?\n/g, "") + "' found.", { line: 1, col: 1 });
  } else
    return p("InvalidXml", "Start tag expected.", 1);
  return !0;
};
function U(e) {
  return e === " " || e === "	" || e === `
` || e === "\r";
}
function G(e, t) {
  const r = t;
  for (; t < e.length; t++)
    if (e[t] == "?" || e[t] == " ") {
      const s = e.substr(r, t - r);
      if (t > 5 && s === "xml")
        return p("InvalidXml", "XML declaration allowed only at the start of the document.", w(e, t));
      if (e[t] == "?" && e[t + 1] == ">") {
        t++;
        break;
      } else
        continue;
    }
  return t;
}
function z(e, t) {
  if (e.length > t + 5 && e[t + 1] === "-" && e[t + 2] === "-") {
    for (t += 3; t < e.length; t++)
      if (e[t] === "-" && e[t + 1] === "-" && e[t + 2] === ">") {
        t += 2;
        break;
      }
  } else if (e.length > t + 8 && e[t + 1] === "D" && e[t + 2] === "O" && e[t + 3] === "C" && e[t + 4] === "T" && e[t + 5] === "Y" && e[t + 6] === "P" && e[t + 7] === "E") {
    let r = 1;
    for (t += 8; t < e.length; t++)
      if (e[t] === "<")
        r++;
      else if (e[t] === ">" && (r--, r === 0))
        break;
  } else if (e.length > t + 9 && e[t + 1] === "[" && e[t + 2] === "C" && e[t + 3] === "D" && e[t + 4] === "A" && e[t + 5] === "T" && e[t + 6] === "A" && e[t + 7] === "[") {
    for (t += 8; t < e.length; t++)
      if (e[t] === "]" && e[t + 1] === "]" && e[t + 2] === ">") {
        t += 2;
        break;
      }
  }
  return t;
}
const Ce = '"', Pe = "'";
function xe(e, t) {
  let r = "", s = "", n = !1;
  for (; t < e.length; t++) {
    if (e[t] === Ce || e[t] === Pe)
      s === "" ? s = e[t] : s !== e[t] || (s = "");
    else if (e[t] === ">" && s === "") {
      n = !0;
      break;
    }
    r += e[t];
  }
  return s !== "" ? !1 : {
    value: r,
    index: t,
    tagClosed: n
  };
}
const $e = new RegExp(`(\\s*)([^\\s=]+)(\\s*=)?(\\s*(['"])(([\\s\\S])*?)\\5)?`, "g");
function H(e, t) {
  const r = M.getAllMatches(e, $e), s = {};
  for (let n = 0; n < r.length; n++) {
    if (r[n][1].length === 0)
      return p("InvalidAttr", "Attribute '" + r[n][2] + "' has no space in starting.", v(r[n]));
    if (r[n][3] !== void 0 && r[n][4] === void 0)
      return p("InvalidAttr", "Attribute '" + r[n][2] + "' is without value.", v(r[n]));
    if (r[n][3] === void 0 && !t.allowBooleanAttributes)
      return p("InvalidAttr", "boolean attribute '" + r[n][2] + "' is not allowed.", v(r[n]));
    const i = r[n][2];
    if (!Le(i))
      return p("InvalidAttr", "Attribute '" + i + "' is an invalid name.", v(r[n]));
    if (!s.hasOwnProperty(i))
      s[i] = 1;
    else
      return p("InvalidAttr", "Attribute '" + i + "' is repeated.", v(r[n]));
  }
  return !0;
}
function Fe(e, t) {
  let r = /\d/;
  for (e[t] === "x" && (t++, r = /[\da-fA-F]/); t < e.length; t++) {
    if (e[t] === ";")
      return t;
    if (!e[t].match(r))
      break;
  }
  return -1;
}
function Ve(e, t) {
  if (t++, e[t] === ";")
    return -1;
  if (e[t] === "#")
    return t++, Fe(e, t);
  let r = 0;
  for (; t < e.length; t++, r++)
    if (!(e[t].match(/\w/) && r < 20)) {
      if (e[t] === ";")
        break;
      return -1;
    }
  return t;
}
function p(e, t, r) {
  return {
    err: {
      code: e,
      msg: t,
      line: r.line || r,
      col: r.col
    }
  };
}
function Le(e) {
  return M.isName(e);
}
function Re(e) {
  return M.isName(e);
}
function w(e, t) {
  const r = e.substring(0, t).split(/\r?\n/);
  return {
    line: r.length,
    // column number is last line's length + 1, because column numbering starts at 1:
    col: r[r.length - 1].length + 1
  };
}
function v(e) {
  return e.startIndex + e[1].length;
}
var k = {};
const re = {
  preserveOrder: !1,
  attributeNamePrefix: "@_",
  attributesGroupName: !1,
  textNodeName: "#text",
  ignoreAttributes: !0,
  removeNSPrefix: !1,
  // remove NS from tag name or attribute name if true
  allowBooleanAttributes: !1,
  //a tag can have attributes without any value
  //ignoreRootElement : false,
  parseTagValue: !0,
  parseAttributeValue: !1,
  trimValues: !0,
  //Trim string values of tag and attributes
  cdataPropName: !1,
  numberParseOptions: {
    hex: !0,
    leadingZeros: !0,
    eNotation: !0
  },
  tagValueProcessor: function(e, t) {
    return t;
  },
  attributeValueProcessor: function(e, t) {
    return t;
  },
  stopNodes: [],
  //nested tags will not be parsed even for errors
  alwaysCreateTextNode: !1,
  isArray: () => !1,
  commentPropName: !1,
  unpairedTags: [],
  processEntities: !0,
  htmlEntities: !1,
  ignoreDeclaration: !1,
  ignorePiTags: !1,
  transformTagName: !1,
  transformAttributeName: !1,
  updateTag: function(e, t, r) {
    return e;
  }
  // skipEmptyListItem: false
}, Se = function(e) {
  return Object.assign({}, re, e);
};
k.buildOptions = Se;
k.defaultOptions = re;
class Me {
  constructor(t) {
    this.tagname = t, this.child = [], this[":@"] = {};
  }
  add(t, r) {
    t === "__proto__" && (t = "#__proto__"), this.child.push({ [t]: r });
  }
  addChild(t) {
    t.tagname === "__proto__" && (t.tagname = "#__proto__"), t[":@"] && Object.keys(t[":@"]).length > 0 ? this.child.push({ [t.tagname]: t.child, ":@": t[":@"] }) : this.child.push({ [t.tagname]: t.child });
  }
}
var ke = Me;
const Be = O;
function qe(e, t) {
  const r = {};
  if (e[t + 3] === "O" && e[t + 4] === "C" && e[t + 5] === "T" && e[t + 6] === "Y" && e[t + 7] === "P" && e[t + 8] === "E") {
    t = t + 9;
    let s = 1, n = !1, i = !1, d = "";
    for (; t < e.length; t++)
      if (e[t] === "<" && !i) {
        if (n && Ge(e, t))
          t += 7, [entityName, val, t] = Xe(e, t + 1), val.indexOf("&") === -1 && (r[We(entityName)] = {
            regx: RegExp(`&${entityName};`, "g"),
            val
          });
        else if (n && ze(e, t))
          t += 8;
        else if (n && He(e, t))
          t += 8;
        else if (n && Ke(e, t))
          t += 9;
        else if (Ue)
          i = !0;
        else
          throw new Error("Invalid DOCTYPE");
        s++, d = "";
      } else if (e[t] === ">") {
        if (i ? e[t - 1] === "-" && e[t - 2] === "-" && (i = !1, s--) : s--, s === 0)
          break;
      } else
        e[t] === "[" ? n = !0 : d += e[t];
    if (s !== 0)
      throw new Error("Unclosed DOCTYPE");
  } else
    throw new Error("Invalid Tag instead of DOCTYPE");
  return { entities: r, i: t };
}
function Xe(e, t) {
  let r = "";
  for (; t < e.length && e[t] !== "'" && e[t] !== '"'; t++)
    r += e[t];
  if (r = r.trim(), r.indexOf(" ") !== -1)
    throw new Error("External entites are not supported");
  const s = e[t++];
  let n = "";
  for (; t < e.length && e[t] !== s; t++)
    n += e[t];
  return [r, n, t];
}
function Ue(e, t) {
  return e[t + 1] === "!" && e[t + 2] === "-" && e[t + 3] === "-";
}
function Ge(e, t) {
  return e[t + 1] === "!" && e[t + 2] === "E" && e[t + 3] === "N" && e[t + 4] === "T" && e[t + 5] === "I" && e[t + 6] === "T" && e[t + 7] === "Y";
}
function ze(e, t) {
  return e[t + 1] === "!" && e[t + 2] === "E" && e[t + 3] === "L" && e[t + 4] === "E" && e[t + 5] === "M" && e[t + 6] === "E" && e[t + 7] === "N" && e[t + 8] === "T";
}
function He(e, t) {
  return e[t + 1] === "!" && e[t + 2] === "A" && e[t + 3] === "T" && e[t + 4] === "T" && e[t + 5] === "L" && e[t + 6] === "I" && e[t + 7] === "S" && e[t + 8] === "T";
}
function Ke(e, t) {
  return e[t + 1] === "!" && e[t + 2] === "N" && e[t + 3] === "O" && e[t + 4] === "T" && e[t + 5] === "A" && e[t + 6] === "T" && e[t + 7] === "I" && e[t + 8] === "O" && e[t + 9] === "N";
}
function We(e) {
  if (Be.isName(e))
    return e;
  throw new Error(`Invalid entity name ${e}`);
}
var Ze = qe;
const je = /^[-+]?0x[a-fA-F0-9]+$/, Ye = /^([\-\+])?(0*)(\.[0-9]+([eE]\-?[0-9]+)?|[0-9]+(\.[0-9]+([eE]\-?[0-9]+)?)?)$/;
!Number.parseInt && window.parseInt && (Number.parseInt = window.parseInt);
!Number.parseFloat && window.parseFloat && (Number.parseFloat = window.parseFloat);
const Je = {
  hex: !0,
  leadingZeros: !0,
  decimalPoint: ".",
  eNotation: !0
  //skipLike: /regex/
};
function Qe(e, t = {}) {
  if (t = Object.assign({}, Je, t), !e || typeof e != "string")
    return e;
  let r = e.trim();
  if (t.skipLike !== void 0 && t.skipLike.test(r))
    return e;
  if (t.hex && je.test(r))
    return Number.parseInt(r, 16);
  {
    const s = Ye.exec(r);
    if (s) {
      const n = s[1], i = s[2];
      let d = De(s[3]);
      const u = s[4] || s[6];
      if (!t.leadingZeros && i.length > 0 && n && r[2] !== ".")
        return e;
      if (!t.leadingZeros && i.length > 0 && !n && r[1] !== ".")
        return e;
      {
        const o = Number(r), a = "" + o;
        return a.search(/[eE]/) !== -1 || u ? t.eNotation ? o : e : r.indexOf(".") !== -1 ? a === "0" && d === "" || a === d || n && a === "-" + d ? o : e : i ? d === a || n + d === a ? o : e : r === a || r === n + a ? o : e;
      }
    } else
      return e;
  }
}
function De(e) {
  return e && e.indexOf(".") !== -1 && (e = e.replace(/0+$/, ""), e === "." ? e = "0" : e[0] === "." ? e = "0" + e : e[e.length - 1] === "." && (e = e.substr(0, e.length - 1))), e;
}
var et = Qe;
const B = O, T = ke, tt = Ze, rt = et;
"<((!\\[CDATA\\[([\\s\\S]*?)(]]>))|((NAME:)?(NAME))([^>]*)>|((\\/)(NAME)\\s*>))([^<]*)".replace(/NAME/g, B.nameRegexp);
let nt = class {
  constructor(t) {
    this.options = t, this.currentNode = null, this.tagsNodeStack = [], this.docTypeEntities = {}, this.lastEntities = {
      apos: { regex: /&(apos|#39|#x27);/g, val: "'" },
      gt: { regex: /&(gt|#62|#x3E);/g, val: ">" },
      lt: { regex: /&(lt|#60|#x3C);/g, val: "<" },
      quot: { regex: /&(quot|#34|#x22);/g, val: '"' }
    }, this.ampEntity = { regex: /&(amp|#38|#x26);/g, val: "&" }, this.htmlEntities = {
      space: { regex: /&(nbsp|#160);/g, val: " " },
      // "lt" : { regex: /&(lt|#60);/g, val: "<" },
      // "gt" : { regex: /&(gt|#62);/g, val: ">" },
      // "amp" : { regex: /&(amp|#38);/g, val: "&" },
      // "quot" : { regex: /&(quot|#34);/g, val: "\"" },
      // "apos" : { regex: /&(apos|#39);/g, val: "'" },
      cent: { regex: /&(cent|#162);/g, val: "¢" },
      pound: { regex: /&(pound|#163);/g, val: "£" },
      yen: { regex: /&(yen|#165);/g, val: "¥" },
      euro: { regex: /&(euro|#8364);/g, val: "€" },
      copyright: { regex: /&(copy|#169);/g, val: "©" },
      reg: { regex: /&(reg|#174);/g, val: "®" },
      inr: { regex: /&(inr|#8377);/g, val: "₹" }
    }, this.addExternalEntities = it, this.parseXml = at, this.parseTextData = st, this.resolveNameSpace = ot, this.buildAttributesMap = dt, this.isItStopNode = ht, this.replaceEntitiesValue = ft, this.readStopNodeData = gt, this.saveTextToParentTag = ct, this.addChild = lt;
  }
};
function it(e) {
  const t = Object.keys(e);
  for (let r = 0; r < t.length; r++) {
    const s = t[r];
    this.lastEntities[s] = {
      regex: new RegExp("&" + s + ";", "g"),
      val: e[s]
    };
  }
}
function st(e, t, r, s, n, i, d) {
  if (e !== void 0 && (this.options.trimValues && !s && (e = e.trim()), e.length > 0)) {
    d || (e = this.replaceEntitiesValue(e));
    const u = this.options.tagValueProcessor(t, e, r, n, i);
    return u == null ? e : typeof u != typeof e || u !== e ? u : this.options.trimValues ? $(e, this.options.parseTagValue, this.options.numberParseOptions) : e.trim() === e ? $(e, this.options.parseTagValue, this.options.numberParseOptions) : e;
  }
}
function ot(e) {
  if (this.options.removeNSPrefix) {
    const t = e.split(":"), r = e.charAt(0) === "/" ? "/" : "";
    if (t[0] === "xmlns")
      return "";
    t.length === 2 && (e = r + t[1]);
  }
  return e;
}
const ut = new RegExp(`([^\\s=]+)\\s*(=\\s*(['"])([\\s\\S]*?)\\3)?`, "gm");
function dt(e, t, r) {
  if (!this.options.ignoreAttributes && typeof e == "string") {
    const s = B.getAllMatches(e, ut), n = s.length, i = {};
    for (let d = 0; d < n; d++) {
      const u = this.resolveNameSpace(s[d][1]);
      let o = s[d][4], a = this.options.attributeNamePrefix + u;
      if (u.length)
        if (this.options.transformAttributeName && (a = this.options.transformAttributeName(a)), a === "__proto__" && (a = "#__proto__"), o !== void 0) {
          this.options.trimValues && (o = o.trim()), o = this.replaceEntitiesValue(o);
          const l = this.options.attributeValueProcessor(u, o, t);
          l == null ? i[a] = o : typeof l != typeof o || l !== o ? i[a] = l : i[a] = $(
            o,
            this.options.parseAttributeValue,
            this.options.numberParseOptions
          );
        } else
          this.options.allowBooleanAttributes && (i[a] = !0);
    }
    if (!Object.keys(i).length)
      return;
    if (this.options.attributesGroupName) {
      const d = {};
      return d[this.options.attributesGroupName] = i, d;
    }
    return i;
  }
}
const at = function(e) {
  e = e.replace(/\r\n?/g, `
`);
  const t = new T("!xml");
  let r = t, s = "", n = "";
  for (let i = 0; i < e.length; i++)
    if (e[i] === "<")
      if (e[i + 1] === "/") {
        const u = y(e, ">", i, "Closing Tag is not closed.");
        let o = e.substring(i + 2, u).trim();
        if (this.options.removeNSPrefix) {
          const f = o.indexOf(":");
          f !== -1 && (o = o.substr(f + 1));
        }
        this.options.transformTagName && (o = this.options.transformTagName(o)), r && (s = this.saveTextToParentTag(s, r, n));
        const a = n.substring(n.lastIndexOf(".") + 1);
        if (o && this.options.unpairedTags.indexOf(o) !== -1)
          throw new Error(`Unpaired tag can not be used as closing tag: </${o}>`);
        let l = 0;
        a && this.options.unpairedTags.indexOf(a) !== -1 ? (l = n.lastIndexOf(".", n.lastIndexOf(".") - 1), this.tagsNodeStack.pop()) : l = n.lastIndexOf("."), n = n.substring(0, l), r = this.tagsNodeStack.pop(), s = "", i = u;
      } else if (e[i + 1] === "?") {
        let u = x(e, i, !1, "?>");
        if (!u)
          throw new Error("Pi Tag is not closed.");
        if (s = this.saveTextToParentTag(s, r, n), !(this.options.ignoreDeclaration && u.tagName === "?xml" || this.options.ignorePiTags)) {
          const o = new T(u.tagName);
          o.add(this.options.textNodeName, ""), u.tagName !== u.tagExp && u.attrExpPresent && (o[":@"] = this.buildAttributesMap(u.tagExp, n, u.tagName)), this.addChild(r, o, n);
        }
        i = u.closeIndex + 1;
      } else if (e.substr(i + 1, 3) === "!--") {
        const u = y(e, "-->", i + 4, "Comment is not closed.");
        if (this.options.commentPropName) {
          const o = e.substring(i + 4, u - 2);
          s = this.saveTextToParentTag(s, r, n), r.add(this.options.commentPropName, [{ [this.options.textNodeName]: o }]);
        }
        i = u;
      } else if (e.substr(i + 1, 2) === "!D") {
        const u = tt(e, i);
        this.docTypeEntities = u.entities, i = u.i;
      } else if (e.substr(i + 1, 2) === "![") {
        const u = y(e, "]]>", i, "CDATA is not closed.") - 2, o = e.substring(i + 9, u);
        if (s = this.saveTextToParentTag(s, r, n), this.options.cdataPropName)
          r.add(this.options.cdataPropName, [{ [this.options.textNodeName]: o }]);
        else {
          let a = this.parseTextData(o, r.tagname, n, !0, !1, !0);
          a == null && (a = ""), r.add(this.options.textNodeName, a);
        }
        i = u + 2;
      } else {
        let u = x(e, i, this.options.removeNSPrefix), o = u.tagName;
        const a = u.rawTagName;
        let l = u.tagExp, f = u.attrExpPresent, c = u.closeIndex;
        this.options.transformTagName && (o = this.options.transformTagName(o)), r && s && r.tagname !== "!xml" && (s = this.saveTextToParentTag(s, r, n, !1));
        const g = r;
        if (g && this.options.unpairedTags.indexOf(g.tagname) !== -1 && (r = this.tagsNodeStack.pop(), n = n.substring(0, n.lastIndexOf("."))), o !== t.tagname && (n += n ? "." + o : o), this.isItStopNode(this.options.stopNodes, n, o)) {
          let h = "";
          if (l.length > 0 && l.lastIndexOf("/") === l.length - 1)
            i = u.closeIndex;
          else if (this.options.unpairedTags.indexOf(o) !== -1)
            i = u.closeIndex;
          else {
            const E = this.readStopNodeData(e, a, c + 1);
            if (!E)
              throw new Error(`Unexpected end of ${a}`);
            i = E.i, h = E.tagContent;
          }
          const _ = new T(o);
          o !== l && f && (_[":@"] = this.buildAttributesMap(l, n, o)), h && (h = this.parseTextData(h, o, n, !0, f, !0, !0)), n = n.substr(0, n.lastIndexOf(".")), _.add(this.options.textNodeName, h), this.addChild(r, _, n);
        } else {
          if (l.length > 0 && l.lastIndexOf("/") === l.length - 1) {
            o[o.length - 1] === "/" ? (o = o.substr(0, o.length - 1), n = n.substr(0, n.length - 1), l = o) : l = l.substr(0, l.length - 1), this.options.transformTagName && (o = this.options.transformTagName(o));
            const h = new T(o);
            o !== l && f && (h[":@"] = this.buildAttributesMap(l, n, o)), this.addChild(r, h, n), n = n.substr(0, n.lastIndexOf("."));
          } else {
            const h = new T(o);
            this.tagsNodeStack.push(r), o !== l && f && (h[":@"] = this.buildAttributesMap(l, n, o)), this.addChild(r, h, n), r = h;
          }
          s = "", i = c;
        }
      }
    else
      s += e[i];
  return t.child;
};
function lt(e, t, r) {
  const s = this.options.updateTag(t.tagname, r, t[":@"]);
  s === !1 || (typeof s == "string" && (t.tagname = s), e.addChild(t));
}
const ft = function(e) {
  if (this.options.processEntities) {
    for (let t in this.docTypeEntities) {
      const r = this.docTypeEntities[t];
      e = e.replace(r.regx, r.val);
    }
    for (let t in this.lastEntities) {
      const r = this.lastEntities[t];
      e = e.replace(r.regex, r.val);
    }
    if (this.options.htmlEntities)
      for (let t in this.htmlEntities) {
        const r = this.htmlEntities[t];
        e = e.replace(r.regex, r.val);
      }
    e = e.replace(this.ampEntity.regex, this.ampEntity.val);
  }
  return e;
};
function ct(e, t, r, s) {
  return e && (s === void 0 && (s = Object.keys(t.child).length === 0), e = this.parseTextData(
    e,
    t.tagname,
    r,
    !1,
    t[":@"] ? Object.keys(t[":@"]).length !== 0 : !1,
    s
  ), e !== void 0 && e !== "" && t.add(this.options.textNodeName, e), e = ""), e;
}
function ht(e, t, r) {
  const s = "*." + r;
  for (const n in e) {
    const i = e[n];
    if (s === i || t === i)
      return !0;
  }
  return !1;
}
function pt(e, t, r = ">") {
  let s, n = "";
  for (let i = t; i < e.length; i++) {
    let d = e[i];
    if (s)
      d === s && (s = "");
    else if (d === '"' || d === "'")
      s = d;
    else if (d === r[0])
      if (r[1]) {
        if (e[i + 1] === r[1])
          return {
            data: n,
            index: i
          };
      } else
        return {
          data: n,
          index: i
        };
    else
      d === "	" && (d = " ");
    n += d;
  }
}
function y(e, t, r, s) {
  const n = e.indexOf(t, r);
  if (n === -1)
    throw new Error(s);
  return n + t.length - 1;
}
function x(e, t, r, s = ">") {
  const n = pt(e, t + 1, s);
  if (!n)
    return;
  let i = n.data;
  const d = n.index, u = i.search(/\s/);
  let o = i, a = !0;
  u !== -1 && (o = i.substr(0, u).replace(/\s\s*$/, ""), i = i.substr(u + 1));
  const l = o;
  if (r) {
    const f = o.indexOf(":");
    f !== -1 && (o = o.substr(f + 1), a = o !== n.data.substr(f + 1));
  }
  return {
    tagName: o,
    tagExp: i,
    closeIndex: d,
    attrExpPresent: a,
    rawTagName: l
  };
}
function gt(e, t, r) {
  const s = r;
  let n = 1;
  for (; r < e.length; r++)
    if (e[r] === "<")
      if (e[r + 1] === "/") {
        const i = y(e, ">", r, `${t} is not closed`);
        if (e.substring(r + 2, i).trim() === t && (n--, n === 0))
          return {
            tagContent: e.substring(s, r),
            i
          };
        r = i;
      } else if (e[r + 1] === "?")
        r = y(e, "?>", r + 1, "StopNode is not closed.");
      else if (e.substr(r + 1, 3) === "!--")
        r = y(e, "-->", r + 3, "StopNode is not closed.");
      else if (e.substr(r + 1, 2) === "![")
        r = y(e, "]]>", r, "StopNode is not closed.") - 2;
      else {
        const i = x(e, r, ">");
        i && ((i && i.tagName) === t && i.tagExp[i.tagExp.length - 1] !== "/" && n++, r = i.closeIndex);
      }
}
function $(e, t, r) {
  if (t && typeof e == "string") {
    const s = e.trim();
    return s === "true" ? !0 : s === "false" ? !1 : rt(e, r);
  } else
    return B.isExist(e) ? e : "";
}
var wt = nt, ne = {};
function mt(e, t) {
  return ie(e, t);
}
function ie(e, t, r) {
  let s;
  const n = {};
  for (let i = 0; i < e.length; i++) {
    const d = e[i], u = Nt(d);
    let o = "";
    if (r === void 0 ? o = u : o = r + "." + u, u === t.textNodeName)
      s === void 0 ? s = d[u] : s += "" + d[u];
    else {
      if (u === void 0)
        continue;
      if (d[u]) {
        let a = ie(d[u], t, o);
        const l = bt(a, t);
        d[":@"] ? Et(a, d[":@"], o, t) : Object.keys(a).length === 1 && a[t.textNodeName] !== void 0 && !t.alwaysCreateTextNode ? a = a[t.textNodeName] : Object.keys(a).length === 0 && (t.alwaysCreateTextNode ? a[t.textNodeName] = "" : a = ""), n[u] !== void 0 && n.hasOwnProperty(u) ? (Array.isArray(n[u]) || (n[u] = [n[u]]), n[u].push(a)) : t.isArray(u, o, l) ? n[u] = [a] : n[u] = a;
      }
    }
  }
  return typeof s == "string" ? s.length > 0 && (n[t.textNodeName] = s) : s !== void 0 && (n[t.textNodeName] = s), n;
}
function Nt(e) {
  const t = Object.keys(e);
  for (let r = 0; r < t.length; r++) {
    const s = t[r];
    if (s !== ":@")
      return s;
  }
}
function Et(e, t, r, s) {
  if (t) {
    const n = Object.keys(t), i = n.length;
    for (let d = 0; d < i; d++) {
      const u = n[d];
      s.isArray(u, r + "." + u, !0, !0) ? e[u] = [t[u]] : e[u] = t[u];
    }
  }
}
function bt(e, t) {
  const { textNodeName: r } = t, s = Object.keys(e).length;
  return !!(s === 0 || s === 1 && (e[r] || typeof e[r] == "boolean" || e[r] === 0));
}
ne.prettify = mt;
const { buildOptions: yt } = k, _t = wt, { prettify: vt } = ne, Tt = S;
let It = class {
  constructor(t) {
    this.externalEntities = {}, this.options = yt(t);
  }
  /**
   * Parse XML dats to JS object 
   * @param {string|Buffer} xmlData 
   * @param {boolean|Object} validationOption 
   */
  parse(t, r) {
    if (typeof t != "string")
      if (t.toString)
        t = t.toString();
      else
        throw new Error("XML data is accepted in String or Bytes[] form.");
    if (r) {
      r === !0 && (r = {});
      const i = Tt.validate(t, r);
      if (i !== !0)
        throw Error(`${i.err.msg}:${i.err.line}:${i.err.col}`);
    }
    const s = new _t(this.options);
    s.addExternalEntities(this.externalEntities);
    const n = s.parseXml(t);
    return this.options.preserveOrder || n === void 0 ? n : vt(n, this.options);
  }
  /**
   * Add Entity which is not by default supported by this library
   * @param {string} key 
   * @param {string} value 
   */
  addEntity(t, r) {
    if (r.indexOf("&") !== -1)
      throw new Error("Entity value can't have '&'");
    if (t.indexOf("&") !== -1 || t.indexOf(";") !== -1)
      throw new Error("An entity must be set without '&' and ';'. Eg. use '#xD' for '&#xD;'");
    if (r === "&")
      throw new Error("An entity with value '&' is not permitted");
    this.externalEntities[t] = r;
  }
};
var At = It;
const Ot = `
`;
function Ct(e, t) {
  let r = "";
  return t.format && t.indentBy.length > 0 && (r = Ot), se(e, t, "", r);
}
function se(e, t, r, s) {
  let n = "", i = !1;
  for (let d = 0; d < e.length; d++) {
    const u = e[d], o = Pt(u);
    if (o === void 0)
      continue;
    let a = "";
    if (r.length === 0 ? a = o : a = `${r}.${o}`, o === t.textNodeName) {
      let h = u[o];
      xt(a, t) || (h = t.tagValueProcessor(o, h), h = oe(h, t)), i && (n += s), n += h, i = !1;
      continue;
    } else if (o === t.cdataPropName) {
      i && (n += s), n += `<![CDATA[${u[o][0][t.textNodeName]}]]>`, i = !1;
      continue;
    } else if (o === t.commentPropName) {
      n += s + `<!--${u[o][0][t.textNodeName]}-->`, i = !0;
      continue;
    } else if (o[0] === "?") {
      const h = K(u[":@"], t), _ = o === "?xml" ? "" : s;
      let E = u[o][0][t.textNodeName];
      E = E.length !== 0 ? " " + E : "", n += _ + `<${o}${E}${h}?>`, i = !0;
      continue;
    }
    let l = s;
    l !== "" && (l += t.indentBy);
    const f = K(u[":@"], t), c = s + `<${o}${f}`, g = se(u[o], t, a, l);
    t.unpairedTags.indexOf(o) !== -1 ? t.suppressUnpairedNode ? n += c + ">" : n += c + "/>" : (!g || g.length === 0) && t.suppressEmptyNode ? n += c + "/>" : g && g.endsWith(">") ? n += c + `>${g}${s}</${o}>` : (n += c + ">", g && s !== "" && (g.includes("/>") || g.includes("</")) ? n += s + t.indentBy + g + s : n += g, n += `</${o}>`), i = !0;
  }
  return n;
}
function Pt(e) {
  const t = Object.keys(e);
  for (let r = 0; r < t.length; r++) {
    const s = t[r];
    if (e.hasOwnProperty(s) && s !== ":@")
      return s;
  }
}
function K(e, t) {
  let r = "";
  if (e && !t.ignoreAttributes)
    for (let s in e) {
      if (!e.hasOwnProperty(s))
        continue;
      let n = t.attributeValueProcessor(s, e[s]);
      n = oe(n, t), n === !0 && t.suppressBooleanAttributes ? r += ` ${s.substr(t.attributeNamePrefix.length)}` : r += ` ${s.substr(t.attributeNamePrefix.length)}="${n}"`;
    }
  return r;
}
function xt(e, t) {
  e = e.substr(0, e.length - t.textNodeName.length - 1);
  let r = e.substr(e.lastIndexOf(".") + 1);
  for (let s in t.stopNodes)
    if (t.stopNodes[s] === e || t.stopNodes[s] === "*." + r)
      return !0;
  return !1;
}
function oe(e, t) {
  if (e && e.length > 0 && t.processEntities)
    for (let r = 0; r < t.entities.length; r++) {
      const s = t.entities[r];
      e = e.replace(s.regex, s.val);
    }
  return e;
}
var $t = Ct;
const Ft = $t, Vt = {
  attributeNamePrefix: "@_",
  attributesGroupName: !1,
  textNodeName: "#text",
  ignoreAttributes: !0,
  cdataPropName: !1,
  format: !1,
  indentBy: "  ",
  suppressEmptyNode: !1,
  suppressUnpairedNode: !0,
  suppressBooleanAttributes: !0,
  tagValueProcessor: function(e, t) {
    return t;
  },
  attributeValueProcessor: function(e, t) {
    return t;
  },
  preserveOrder: !1,
  commentPropName: !1,
  unpairedTags: [],
  entities: [
    { regex: new RegExp("&", "g"), val: "&amp;" },
    //it must be on top
    { regex: new RegExp(">", "g"), val: "&gt;" },
    { regex: new RegExp("<", "g"), val: "&lt;" },
    { regex: new RegExp("'", "g"), val: "&apos;" },
    { regex: new RegExp('"', "g"), val: "&quot;" }
  ],
  processEntities: !0,
  stopNodes: [],
  // transformTagName: false,
  // transformAttributeName: false,
  oneListGroup: !1
};
function b(e) {
  this.options = Object.assign({}, Vt, e), this.options.ignoreAttributes || this.options.attributesGroupName ? this.isAttribute = function() {
    return !1;
  } : (this.attrPrefixLen = this.options.attributeNamePrefix.length, this.isAttribute = St), this.processTextOrObjNode = Lt, this.options.format ? (this.indentate = Rt, this.tagEndChar = `>
`, this.newLine = `
`) : (this.indentate = function() {
    return "";
  }, this.tagEndChar = ">", this.newLine = "");
}
b.prototype.build = function(e) {
  return this.options.preserveOrder ? Ft(e, this.options) : (Array.isArray(e) && this.options.arrayNodeName && this.options.arrayNodeName.length > 1 && (e = {
    [this.options.arrayNodeName]: e
  }), this.j2x(e, 0).val);
};
b.prototype.j2x = function(e, t) {
  let r = "", s = "";
  for (let n in e)
    if (Object.prototype.hasOwnProperty.call(e, n))
      if (typeof e[n] > "u")
        this.isAttribute(n) && (s += "");
      else if (e[n] === null)
        this.isAttribute(n) ? s += "" : n[0] === "?" ? s += this.indentate(t) + "<" + n + "?" + this.tagEndChar : s += this.indentate(t) + "<" + n + "/" + this.tagEndChar;
      else if (e[n] instanceof Date)
        s += this.buildTextValNode(e[n], n, "", t);
      else if (typeof e[n] != "object") {
        const i = this.isAttribute(n);
        if (i)
          r += this.buildAttrPairStr(i, "" + e[n]);
        else if (n === this.options.textNodeName) {
          let d = this.options.tagValueProcessor(n, "" + e[n]);
          s += this.replaceEntitiesValue(d);
        } else
          s += this.buildTextValNode(e[n], n, "", t);
      } else if (Array.isArray(e[n])) {
        const i = e[n].length;
        let d = "";
        for (let u = 0; u < i; u++) {
          const o = e[n][u];
          typeof o > "u" || (o === null ? n[0] === "?" ? s += this.indentate(t) + "<" + n + "?" + this.tagEndChar : s += this.indentate(t) + "<" + n + "/" + this.tagEndChar : typeof o == "object" ? this.options.oneListGroup ? d += this.j2x(o, t + 1).val : d += this.processTextOrObjNode(o, n, t) : d += this.buildTextValNode(o, n, "", t));
        }
        this.options.oneListGroup && (d = this.buildObjectNode(d, n, "", t)), s += d;
      } else if (this.options.attributesGroupName && n === this.options.attributesGroupName) {
        const i = Object.keys(e[n]), d = i.length;
        for (let u = 0; u < d; u++)
          r += this.buildAttrPairStr(i[u], "" + e[n][i[u]]);
      } else
        s += this.processTextOrObjNode(e[n], n, t);
  return { attrStr: r, val: s };
};
b.prototype.buildAttrPairStr = function(e, t) {
  return t = this.options.attributeValueProcessor(e, "" + t), t = this.replaceEntitiesValue(t), this.options.suppressBooleanAttributes && t === "true" ? " " + e : " " + e + '="' + t + '"';
};
function Lt(e, t, r) {
  const s = this.j2x(e, r + 1);
  return e[this.options.textNodeName] !== void 0 && Object.keys(e).length === 1 ? this.buildTextValNode(e[this.options.textNodeName], t, s.attrStr, r) : this.buildObjectNode(s.val, t, s.attrStr, r);
}
b.prototype.buildObjectNode = function(e, t, r, s) {
  if (e === "")
    return t[0] === "?" ? this.indentate(s) + "<" + t + r + "?" + this.tagEndChar : this.indentate(s) + "<" + t + r + this.closeTag(t) + this.tagEndChar;
  {
    let n = "</" + t + this.tagEndChar, i = "";
    return t[0] === "?" && (i = "?", n = ""), (r || r === "") && e.indexOf("<") === -1 ? this.indentate(s) + "<" + t + r + i + ">" + e + n : this.options.commentPropName !== !1 && t === this.options.commentPropName && i.length === 0 ? this.indentate(s) + `<!--${e}-->` + this.newLine : this.indentate(s) + "<" + t + r + i + this.tagEndChar + e + this.indentate(s) + n;
  }
};
b.prototype.closeTag = function(e) {
  let t = "";
  return this.options.unpairedTags.indexOf(e) !== -1 ? this.options.suppressUnpairedNode || (t = "/") : this.options.suppressEmptyNode ? t = "/" : t = `></${e}`, t;
};
b.prototype.buildTextValNode = function(e, t, r, s) {
  if (this.options.cdataPropName !== !1 && t === this.options.cdataPropName)
    return this.indentate(s) + `<![CDATA[${e}]]>` + this.newLine;
  if (this.options.commentPropName !== !1 && t === this.options.commentPropName)
    return this.indentate(s) + `<!--${e}-->` + this.newLine;
  if (t[0] === "?")
    return this.indentate(s) + "<" + t + r + "?" + this.tagEndChar;
  {
    let n = this.options.tagValueProcessor(t, e);
    return n = this.replaceEntitiesValue(n), n === "" ? this.indentate(s) + "<" + t + r + this.closeTag(t) + this.tagEndChar : this.indentate(s) + "<" + t + r + ">" + n + "</" + t + this.tagEndChar;
  }
};
b.prototype.replaceEntitiesValue = function(e) {
  if (e && e.length > 0 && this.options.processEntities)
    for (let t = 0; t < this.options.entities.length; t++) {
      const r = this.options.entities[t];
      e = e.replace(r.regex, r.val);
    }
  return e;
};
function Rt(e) {
  return this.options.indentBy.repeat(e);
}
function St(e) {
  return e.startsWith(this.options.attributeNamePrefix) && e !== this.options.textNodeName ? e.substr(this.attrPrefixLen) : !1;
}
var Mt = b;
const kt = S, Bt = At, qt = Mt;
var W = {
  XMLParser: Bt,
  XMLValidator: kt,
  XMLBuilder: qt
};
function Xt(e) {
  if (typeof e != "string")
    throw new TypeError(`Expected a \`string\`, got \`${typeof e}\``);
  if (e = e.trim(), e.length === 0 || W.XMLValidator.validate(e) !== !0)
    return !1;
  let t;
  const r = new W.XMLParser();
  try {
    t = r.parse(e);
  } catch {
    return !1;
  }
  return !(!t || !("svg" in t));
}
/**
 * @copyright Copyright (c) 2022 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
class cr {
  _view;
  constructor(t) {
    Ut(t), this._view = t;
  }
  get id() {
    return this._view.id;
  }
  get name() {
    return this._view.name;
  }
  get caption() {
    return this._view.caption;
  }
  get emptyTitle() {
    return this._view.emptyTitle;
  }
  get emptyCaption() {
    return this._view.emptyCaption;
  }
  get getContents() {
    return this._view.getContents;
  }
  get icon() {
    return this._view.icon;
  }
  set icon(t) {
    this._view.icon = t;
  }
  get order() {
    return this._view.order;
  }
  set order(t) {
    this._view.order = t;
  }
  get params() {
    return this._view.params;
  }
  set params(t) {
    this._view.params = t;
  }
  get columns() {
    return this._view.columns;
  }
  get emptyView() {
    return this._view.emptyView;
  }
  get parent() {
    return this._view.parent;
  }
  get sticky() {
    return this._view.sticky;
  }
  get expanded() {
    return this._view.expanded;
  }
  set expanded(t) {
    this._view.expanded = t;
  }
  get defaultSortKey() {
    return this._view.defaultSortKey;
  }
}
const Ut = function(e) {
  if (!e.id || typeof e.id != "string")
    throw new Error("View id is required and must be a string");
  if (!e.name || typeof e.name != "string")
    throw new Error("View name is required and must be a string");
  if (e.columns && e.columns.length > 0 && (!e.caption || typeof e.caption != "string"))
    throw new Error("View caption is required for top-level views and must be a string");
  if (!e.getContents || typeof e.getContents != "function")
    throw new Error("View getContents is required and must be a function");
  if (!e.icon || typeof e.icon != "string" || !Xt(e.icon))
    throw new Error("View icon is required and must be a valid svg string");
  if (!("order" in e) || typeof e.order != "number")
    throw new Error("View order is required and must be a number");
  if (e.columns && e.columns.forEach((t) => {
    if (!(t instanceof Ie))
      throw new Error("View columns must be an array of Column. Invalid column found");
  }), e.emptyView && typeof e.emptyView != "function")
    throw new Error("View emptyView must be a function");
  if (e.parent && typeof e.parent != "string")
    throw new Error("View parent must be a string");
  if ("sticky" in e && typeof e.sticky != "boolean")
    throw new Error("View sticky must be a boolean");
  if ("expanded" in e && typeof e.expanded != "boolean")
    throw new Error("View expanded must be a boolean");
  if (e.defaultSortKey && typeof e.defaultSortKey != "string")
    throw new Error("View defaultSortKey must be a string");
  return !0;
};
/**
 * @copyright 2019 Christoph Wurst <christoph@winzerhof-wurst.at>
 *
 * @author Christoph Wurst <christoph@winzerhof-wurst.at>
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
const hr = function(e) {
  return F().registerEntry(e);
}, pr = function(e) {
  return F().unregisterEntry(e);
}, gr = function(e) {
  return F().getEntries(e).sort((r, s) => r.order !== void 0 && s.order !== void 0 && r.order !== s.order ? r.order - s.order : r.displayName.localeCompare(s.displayName, void 0, { numeric: !0, sensitivity: "base" }));
};
export {
  Ie as Column,
  Z as DefaultType,
  ye as File,
  Qt as FileAction,
  R as FileType,
  _e as Folder,
  tr as Header,
  Te as Navigation,
  D as Node,
  Q as NodeStatus,
  N as Permission,
  cr as View,
  hr as addNewFileMenuEntry,
  ur as davGetClient,
  sr as davGetDefaultPropfind,
  Ee as davGetFavoritesReport,
  or as davGetRecentSearch,
  be as davParsePermissions,
  te as davRemoteURL,
  ve as davResultToNode,
  ee as davRootPath,
  Y as defaultDavNamespaces,
  j as defaultDavProperties,
  Yt as formatFileSize,
  L as getDavNameSpaces,
  V as getDavProperties,
  dr as getFavoriteNodes,
  er as getFileActions,
  nr as getFileListHeaders,
  ar as getNavigation,
  gr as getNewFileMenuEntries,
  Jt as parseFileSize,
  ir as registerDavProperty,
  Dt as registerFileAction,
  rr as registerFileListHeaders,
  pr as removeNewFileMenuEntry
};
